var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ItemGroup } from 'rc-menu';
import * as React from 'react';
import { forwardRef, useImperativeHandle, useMemo, useRef } from 'react';
import { TinyColor } from '@ctrl/tinycolor';
import InternalMenu from './menu';
import { SiderContext } from '../layout/Sider';
import { MenuTheme } from './MenuContext';
import MenuDivider from './MenuDivider';
import Item, { MenuItemProps } from './MenuItem';
import SubMenu, { SubMenuProps } from './SubMenu';
import { ConfigProvider } from '..';
import { useToken } from '../theme';
export { MenuItemGroupProps } from 'rc-menu';
export { MenuDividerProps } from './MenuDivider';
export { MenuTheme, SubMenuProps, MenuItemProps };
const ThemedMenu = forwardRef((_a, ref) => {
    var { theme = 'light' } = _a, rest = __rest(_a, ["theme"]);
    const menuRef = useRef(null);
    const [, token] = useToken();
    useImperativeHandle(ref, () => ({
        focus: options => {
            var _a;
            (_a = menuRef.current) === null || _a === void 0 ? void 0 : _a.focus(options);
        },
        menu: menuRef.current,
    }));
    const { colorTextLightSolid, colorTextSecondary, colorPrimary, colorError, colorErrorHover } = token;
    const darkThemeToken = useMemo(() => {
        if (theme === 'dark') {
            return {
                colorItemText: new TinyColor(colorTextLightSolid).setAlpha(0.65).toRgbString(),
                colorItemTextHover: colorTextLightSolid,
                colorGroupTitle: colorTextSecondary,
                colorItemTextSelected: colorTextLightSolid,
                colorItemBg: '#001529',
                colorSubItemBg: '#000c17',
                colorItemBgActive: 'transparent',
                colorItemBgSelected: colorPrimary,
                colorActiveBarWidth: 0,
                colorActiveBarHeight: 0,
                colorActiveBarBorderSize: 0,
                // Disabled
                colorItemTextDisabled: new TinyColor(colorTextLightSolid).setAlpha(0.25).toRgbString(),
                // Danger
                colorDangerItemText: colorError,
                colorDangerItemTextHover: colorErrorHover,
                colorDangerItemTextSelected: colorTextLightSolid,
                colorDangerItemBgActive: colorError,
                colorDangerItemBgSelected: colorError,
            };
        }
        return {};
    }, [theme]);
    return (React.createElement(ConfigProvider, { theme: { override: { Menu: darkThemeToken } } },
        React.createElement(SiderContext.Consumer, null, (context) => React.createElement(InternalMenu, Object.assign({ ref: menuRef }, rest, context)))));
});
const Menu = ThemedMenu;
Menu.Divider = MenuDivider;
Menu.Item = Item;
Menu.SubMenu = SubMenu;
Menu.ItemGroup = ItemGroup;
export default Menu;
